/**
 * <EmptyState> — friendly empty state for lists, dashboards and tabs
 * (SELFSERVE_MODULE_SPEC §17.5.d). Compose with `lucide-react` icons.
 */
import React from 'react';

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  testId = 'empty-state',
  className = '',
}) => (
  <div
    className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}
    data-testid={testId}
  >
    {Icon && (
      <div className="rounded-full bg-muted p-3 mb-4" data-testid={`${testId}-icon`}>
        <Icon className="w-6 h-6 text-muted-foreground" />
      </div>
    )}
    <h3 className="text-base font-medium mb-1" data-testid={`${testId}-title`}>
      {title}
    </h3>
    {description && (
      <p className="text-sm text-muted-foreground max-w-md mb-4" data-testid={`${testId}-description`}>
        {description}
      </p>
    )}
    {action}
  </div>
);

export default EmptyState;
